module.exports = __webpack_public_path__ + "08a1a46dc4a0969ecc9edb5c10c19c97.svg";